import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { B05aPurchaseInfoPage } from '../b05a-purchase-info/b05a-purchase-info';
import { B05bPurchaseAddPage } from '../b05b-purchase-add/b05b-purchase-add';
import { ServiceApiProvider } from '../../providers/service-api/service-api';


/**
 * Generated class for the B05PurchaseOrderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface purchaseInfo{
  PO_ID: number;
  PO_NO: string;
  REMARKS: string; 
  TOTAL_FOREX: string;
  TOTAL_LOCAL: string;  
  TOTAL_TAX: string; 
  GRAND_TOTAL: string;  
  DATETIME: string; 
  PO_STATUS_ID: number;
  PO_TYPE_ID: number;
  SUPPLIER_ID: number;
  CURRENCY_ID: number;
  ACTION_BY: number;
}

interface purchasestatus{
  PO_STATUS_ID: number;
  STATUS: string;
  
}
interface currencystatus{
  CURRENCY_ID: number;
  CODE: string;
  RATE: string;
  
}
@IonicPage()
@Component({
  selector: 'page-b05-purchase-order',
  templateUrl: 'b05-purchase-order.html',
})
export class B05PurchaseOrderPage {

  loading: any;
  Status: any;
  purchaseArr: purchaseInfo[] = [];
  purchaseItems: purchaseInfo[] = [];
  postatusArr: purchasestatus[] = [];
  postatusItems: purchasestatus[] = [];
  currencyArr: currencystatus[]=[];
  currencyItems: currencystatus[]=[]
  public errorMessage: any = "";
  public searchMessage:any ="";
  posearch: any = "";
  postate:any = "";
  GRP_ID: any;
  CORP_ID: any;
  userBranchId:any;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public serviceapi: ServiceApiProvider, private toastCtrl: ToastController, 
    public loadingCtrl: LoadingController, public alertCtrl:AlertController) {

      this.GRP_ID = sessionStorage.getItem('usergroupid');
      this.userBranchId = sessionStorage.getItem('userbranchid');
      //this.CORP_ID = sessionStorage.getItem('usercorpid');
      let tbl = ["All"];
      let column = ["All"];
      let value = ["All"];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];
    
      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");


      this.serviceapi.readdata(json_data,"CURRENCY","1","1").then((result) => {
       
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.currencyArr = Records;
          this.currencyItems = this.currencyArr;
          console.log(this.currencyItems);
        

        let sortby= "DATETIME";
        let sorttype= "DESC";
    
        let temp_tbl = [];
        let temp_column = [];
        let temp_value = [];
    
        if(this.GRP_ID=="1") {            //system admin
          temp_tbl = ["All"];
          temp_column = ["All"];
          temp_value = ["All"];
        }
        else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //corporate admin/ manager
          temp_tbl = ["PO"]; 
          temp_column = ["BRANCH_ID"];
          temp_value = [this.userBranchId];
        }
    
        let tbl = temp_tbl;
        let column = temp_column;
        let value = temp_value;
        
        let tblkey = ["SUPPLIER_ID","PO_STATUS_ID"];
        let fktbl = ["SUPPLIER","PO_STATUS"];
        let fkkey = ["SUPPLIER_ID","PO_STATUS_ID"];
      
        let jsonsort = this.serviceapi.sort(sortby,sorttype);
        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    
        let mydata = Object.assign(jsonsort,jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
        this.showLoader();
        this.serviceapi.readdata(json_data,"PO","1","1").then((result) => {
          
          this.Status = result["Message"];
          if (this.Status == '1'){
            
            let Records = result["Records"];
            this.purchaseArr = Records;
            this.purchaseItems = this.purchaseArr;
            console.log(this.purchaseItems);
            //Read PO_STATUS
            let tbl = ["All"];
            let column = ["All"];
            let value = ["All"];
            
            let tblkey = ["No"];
            let fktbl = ["No"];
            let fkkey = ["No"];
          
            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");


            this.serviceapi.readdata(json_data,"PO_STATUS","1","1").then((result) => {
              this.loading.dismiss();
              this.Status = result["Message"];
              if (this.Status == '1'){
                
                let Records = result["Records"];
                this.postatusArr = Records;
                this.postatusItems = this.postatusArr;
              


                


              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();
              }
            }, (err) => {
              this.errorMessage = "Loading Error. Please try again.";
              this.loading.dismiss();
            });
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });
    }
    else {
      this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      this.loading.dismiss();
    }
  }, (err) => {
    this.errorMessage = "Loading Error. Please try again.";
    this.loading.dismiss();
  });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B05PurchaseOrderPage');
  }

  editPO(ID){
    
    this.navCtrl.push(B05aPurchaseInfoPage, {paramID: ID});     
  }

  goToNewPO(){
    this.navCtrl.push(B05bPurchaseAddPage);
  }

  clearItem(){
    this.posearch = "";
    this.postate = "";
  }
  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  searchItem(){
    this.searchMessage="";
    this.errorMessage="";

    let temp_tbl = [];
    let temp_column = [];
    let temp_value = [];
    this.purchaseItems = [];

    let sortby= "No";
    let sorttype= "No";

    if (this.posearch!=""){

      if(this.GRP_ID=="1") {            //system admin
        temp_tbl = ["PO"];
        temp_column = ["PO_NO"];
        temp_value = [this.posearch];
      }
      else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //corporate admin/ manager
        temp_tbl = ["PO","PO"]; 
        temp_column = ["BRANCH_ID","PO_NO"];
        temp_value = [this.userBranchId,this.posearch];
      }
      /*else if ((this.GRP_ID == "6") || (this.GRP_ID == "7")) {      //corporate admin/ manager
        temp_tbl = ["CARD", "CARD"]; 
        temp_column = ["CARD_NO", "CORP_ID"];
        temp_value = [this.cardNumber, this.CORP_ID];
      }
      this.corporate="";*/
    }
    else if (this.postate!=""){
     
      if(this.GRP_ID=="1") {            //system admin
        temp_tbl = ["PO"];
        temp_column = ["PO_STATUS_ID"];
        temp_value = [this.postate];
      }
      else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //corporate admin/ manager
        temp_tbl = ["PO","PO"]; 
        temp_column = ["BRANCH_ID","PO_STATUS_ID"];
        temp_value = [this.userBranchId,this.postate];
      }
      this.posearch="";
    }
    else {

      if(this.GRP_ID=="1") {            //system admin
        temp_tbl = ["All"];
        temp_column = ["All"];
        temp_value = ["All"];
      }
      else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //corporate admin/ manager
        temp_tbl = ["PO"]; 
        temp_column = ["BRANCH_ID"];
        temp_value = [this.userBranchId];
      }
      /*else if ((this.GRP_ID == "6") || (this.GRP_ID == "7")) {      //corporate admin/ manager
        temp_tbl = ["CARD"]; 
        temp_column = ["CORP_ID"];
        temp_value = [this.CORP_ID];
      }*/
    }
   
    let tbl = temp_tbl;
    let column = temp_column;
    let value = temp_value;
    
    let tblkey = ["SUPPLIER_ID","PO_STATUS_ID","CURRENCY_ID"];
    let fktbl = ["SUPPLIER","PO_STATUS","CURRENCY"];
    let fkkey = ["SUPPLIER_ID","PO_STATUS_ID","CURRENCY_ID"];
    
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"PO","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.purchaseArr = Records;
        this.purchaseItems = this.purchaseArr;
        
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
    
  }

  currencychange(id)
  {
    let val = this.currencyItems.find(c => c["CURRENCY_ID"] === id);
    if(val.CODE != null)
    {
      return val.CODE;
    }
  }

  delete(PO_ID)
  {
    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Are you sure you want to cancel this PO? This action cannot be undone.',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
              
            this.updatePO(PO_ID);
          }
        }
      ]
    });
    confirm.present();
  }

  updatePO(PO_ID){
    let data = { PO_STATUS_ID:"5"};
    this.serviceapi.updatedata('PO', 'PO_ID', PO_ID, data).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B05PurchaseOrderPage);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/b05-purchase-order/b05-purchase-order.ts